import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M17.577 19.0001L12.81 14.2341C10.6539 15.6565 7.77106 15.2165 6.13737 13.2156C4.50369 11.2148 4.64914 8.3022 6.47405 6.47407C8.30186 4.64846 11.2148 4.50238 13.216 6.13595C15.2173 7.76953 15.6576 10.6527 14.235 12.8091L19 17.5771L17.577 19.0001ZM10.034 7.01406C8.5933 7.01315 7.35253 8.03008 7.07053 9.44297C6.78854 10.8559 7.54386 12.2712 8.87457 12.8234C10.2053 13.3756 11.7408 12.911 12.542 11.7136C13.3433 10.5162 13.1871 8.91953 12.169 7.90007C11.6043 7.33141 10.8355 7.01236 10.034 7.01406Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SearchSmall"
);
